import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';

export const es = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Aprendizaje',
    PAGE_SUBTITLE:
      'Visualiza el consumo de la plataforma de aprendizaje. Cursos propios vs catálogo Crehana, evolución trimestral, certificaciones y satisfacción.',
    NEW_TAG: 'Nuevo',
    FRESHNESS_PREFIX: 'Última actualización:',
    PRODUCT_SELECTOR_LABEL: 'Producto',
    PRODUCT_SELECTOR_HELPER: 'Selecciona el producto que quieres analizar',
    PRODUCT_GENERAL: 'General',
    PRODUCT_LEARNING: 'Aprendizaje',
    BREADCRUMB_LEARNING: 'Aprendizaje',
    TAB_GENERAL: 'General',
    TAB_PATHS: 'Por rutas',
    TAB_COURSES: 'Por cursos',
    TAB_USERS: 'Por usuarios',
    TAB_PLACEHOLDER_PATHS: 'Contenido de rutas próximamente',
    TAB_PLACEHOLDER_COURSES: 'Contenido de cursos próximamente',
    TAB_PLACEHOLDER_USERS: 'Contenido de usuarios próximamente',
    EMPTY_TITLE: 'No hay módulos disponibles',
    EMPTY_DESCRIPTION:
      'Cuando haya datos de aprendizaje disponibles, los verás aquí.',
    ERROR_TITLE: 'Error al cargar el dashboard',
    ERROR_RETRY: 'Reintentar',
    PERIOD_LABEL: 'Período',
    PERIOD_WEEK: 'Esta semana',
    PERIOD_MONTH: 'Este mes',
    PERIOD_QUARTER: 'Este trimestre',
    PERIOD_YEAR: 'Este año',
    PERIOD_CUSTOM: 'Rango personalizado',
    PERIOD_HINT: 'Las métricas y tablas se recalculan según el período',
    PERIOD_SELECT_ARIA: 'Seleccionar período',
    PERIOD_RANGE_PLACEHOLDER: 'Selecciona un rango',
    SEGMENT_BAR_LABEL: 'Segmentar por',
    SEGMENT_TRIGGER_PLACEHOLDER: 'Selecciona un atributo',
    SEGMENT_SEARCH_PLACEHOLDER: 'Buscar atributo',
    SEGMENT_GROUP_DEFAULT: 'Predeterminados',
    SEGMENT_GROUP_CUSTOM: 'Personalizados',
    SEGMENT_MANAGE_ACTION: 'Gestionar atributos',
    SEGMENT_LOADING: 'Cargando atributos…',
    SEGMENT_ERROR: 'No pudimos cargar los atributos',
    SEGMENT_ERROR_RETRY: 'Reintentar',
    SEGMENT_EMPTY: 'No hay atributos disponibles',
    SEGMENT_NO_RESULTS: 'Sin resultados',
    SEGMENT_SECTION_TITLE: 'Segmentación',
    SEGMENT_TAG_GRANULAR: 'Granular',
    SEGMENT_SECTION_DESC:
      'Reagrupa las métricas por cualquier atributo de tu empresa — los predeterminados de la base de colaboradores o los atributos personalizados que hayas configurado.',
    CERT_SECTION_TITLE: 'Certificados',
    CERT_SECTION_DESC:
      'Un certificado se emite cuando un usuario completa un curso que tiene certificación habilitada. Un mismo usuario puede obtener múltiples certificados (uno por curso completado).',
    HISTORIC_CHIP: 'Histórico · no depende del período',
    CERT_KPI_TOTAL_LABEL: 'Certificados emitidos (Total)',
    CERT_DOWNLOAD_LINK_LABEL: 'Descargar certificados',
    CERT_KPI_USERS_LABEL: 'Usuarios con al menos 1 certificado',
    CERT_KPI_AVG_LABEL: 'Promedio de certificados por usuario',
    CERT_CHART_TITLE: 'Certificados emitidos por mes',
    CERT_CHART_HELPER: 'Últimos 16 meses · Certificados emitidos por mes',
    CERT_CHART_BARS_LEGEND: 'Certificados',
    CSAT_SECTION_TITLE: 'Satisfacción de Encuestas — Rutas clave',
    CSAT_TABLE_TITLE: 'Satisfacción de encuestas por ruta clave',
    CSAT_COL_ROUTE: 'Ruta',
    CSAT_COL_SCORE: 'CSAT (1–5)',
    CSAT_COL_SCORE_TOOLTIP:
      'Promedio del CSAT de los cursos de la ruta. Distinto del rating individual de curso que aparece en el bloque de métricas clave.',
    CSAT_COL_RESPONSES: 'Respuestas',
    CSAT_COL_UNIQUE_USERS: 'Usuarios únicos',
    CSAT_SCORE_SUFFIX: '/5',
    CSAT_EMPTY_TITLE: 'Sin rutas clave',
    CSAT_EMPTY_DESC: 'No hay rutas lanzadas en los últimos 90 días.',
    CSAT_ERROR_TITLE: 'Error al cargar los datos de CSAT',
    CSAT_ERROR_RETRY: 'Reintentar',
    // === ANLT-273 Activity Trends Section ===
    TRENDS_TENDENCIAS_SECTION_TITLE: 'Tendencias',
    TRENDS_HISTORICO_CHIP: 'Histórico · no depende del período',
    TRENDS_NOTE_INSCRIPCION: 'Agrupado por fecha de inscripción',
    TRENDS_NOTE_ACTIVOS: 'Incluye solo colaboradores activos actuales',
    TRENDS_PROPIOS_CATALOGO_TITLE: 'Cursos Propios vs Catálogo Crehana',
    TRENDS_PROPIOS_CATALOGO_HELPER:
      '**Propio** = cursos subidos por la empresa · **Catálogo** = cursos de la biblioteca Crehana. Gráfico muestra enrollments (inscripciones) y completados por trimestre.',
    TRENDS_EVOLUCION_TITLE: 'Evolución Trimestral',
    TRENDS_EVOLUCION_HELPER:
      'Inscriptos + Completados (barras) y % Completion (línea)',
    TRENDS_MENSUAL_TITLE: 'Tendencia Mensual',
    TRENDS_MENSUAL_HELPER:
      'Últimos 15 meses · Inscriptos, Usuarios únicos y Completados',
    TRENDS_DETALLE_TITLE: 'Detalle trimestral',
    TRENDS_DETALLE_HELPER: 'Mismas métricas, valores absolutos · 5 trimestres',
    SERIES_PROPIO_ENR: 'Propios - Inscriptos',
    SERIES_CATALOGO_ENR: 'Catálogo - Inscriptos',
    SERIES_PROPIO_COMP: 'Propios - Completados',
    SERIES_CATALOGO_COMP: 'Catálogo - Completados',
    SERIES_ENROLLMENTS: 'Inscriptos',
    SERIES_UNICOS: 'Usuarios únicos',
    SERIES_COMPLETADOS: 'Completados',
    SERIES_COMPLETION: '% Completion',
    TABLE_PERIODO: 'Período',
    TABLE_ENROLLMENTS: 'Inscriptos',
    TABLE_COMPLETADOS: 'Completados',
    TABLE_CERTIFICADOS: 'Certificados',
    TABLE_USUARIOS_UNICOS: 'Usuarios únicos',
    TABLE_AVG_PROGRESS: 'Avg Progress',
    TABLE_COMPLETION: '% Completion',

    // ── ANLT-279 · Rankings ──────────────────────────────────────────────
    RANK_LEARNERS_TITLE: 'Top Learners',
    RANK_CURSOS_TITLE: 'Top Cursos por Certificados',
    RANK_INACTIVOS_TITLE: 'Usuarios inactivos',
    // AC-4: fixed 30-day threshold, independent of the period filter
    RANK_INACTIVOS_CHIP: 'Sin acceso en 30+ días',

    RANK_COL_RANK: '#',
    RANK_COL_NAME: 'Nombre',
    RANK_COL_ENROLLMENTS: 'Inscripciones',
    RANK_COL_COMPLETED: 'Completados',
    RANK_COL_CERTIFICATES: 'Certificados',
    RANK_COL_HOURS: 'Horas',
    RANK_COL_COURSE: 'Curso',
    RANK_COL_TYPE: 'Tipo',
    RANK_COL_USERS: 'Usuarios',
    RANK_COL_DEPARTMENT: 'Departamento',
    RANK_COL_LOCATION: 'Sede',
    RANK_COL_LAST_ACTIVITY: 'Última actividad',
    RANK_COL_PENDING: 'Cursos pendientes',

    RANK_SOURCE_PROPIO: 'Propio',
    RANK_SOURCE_CATALOGO: 'Catálogo',

    RANK_INACTIVOS_COUNT: '{{count}} colaboradores',
    RANK_INACTIVOS_SUMMARY:
      'sin acceso en más de 30 días · ordenados por inactividad',
    RANK_LAST_ACTIVITY_RELATIVE: 'Hace {{count}} días',
    RANK_LAST_ACTIVITY_NEVER: 'Nunca ingresó',
    RANK_INACTIVOS_NOTE:
      'El envío de recordatorios se gestiona desde Comunicaciones internas',
    RANK_INACTIVOS_LINK: 'Ver los {{count}} usuarios inactivos →',

    RANK_LEARNERS_EMPTY_TITLE: 'Sin datos de learners',
    RANK_LEARNERS_EMPTY_DESC:
      'No hay actividad de aprendizaje en el período seleccionado.',
    RANK_CURSOS_EMPTY_TITLE: 'Sin datos de cursos',
    RANK_CURSOS_EMPTY_DESC:
      'No hay certificados emitidos en el período seleccionado.',
    RANK_INACTIVOS_EMPTY_TITLE: 'Sin usuarios inactivos',
    RANK_INACTIVOS_EMPTY_DESC:
      'No hay usuarios sin acceso en los últimos 30 días. ¡Todo activo!',
    RANK_ERROR_TITLE: 'Error al cargar el ranking',
    RANK_ERROR_RETRY: 'Reintentar',
    // ANLT-275 — Rutas de Aprendizaje (tabla)
    // ── ANLT-275 · Rutas de Aprendizaje ──────────────────────────────────
    LP_SECTION_HEADING: 'Rutas de Aprendizaje',
    LP_FILTER_TIPO_LABEL: 'Tipo:',
    LP_FILTER_TIPO_ALL: 'Todas',
    LP_FILTER_TIPO_MANDATORY: 'Obligatorias',
    LP_FILTER_TIPO_OPTIONAL: 'Opcionales',
    LP_FILTER_ORIGEN_LABEL: 'Origen:',
    LP_FILTER_ORIGEN_ALL: 'Todos',
    LP_FILTER_ORIGEN_OWN: 'Propio',
    LP_FILTER_ORIGEN_CATALOG: 'Catálogo',
    LP_COL_PATH: 'Ruta',
    LP_COL_ENROLLED: 'Inscritos',
    LP_COL_COURSES_COMPLETED: 'Cursos completados',
    LP_COL_PATH_COMPLETED: 'Ruta completada',
    LP_COL_COURSES_REQUIRED: 'Cursos req.',
    LP_COL_COMPLETION: '% Completado',
    LP_TABLE_EMPTY_TITLE: 'Sin datos de rutas',
    LP_TABLE_EMPTY_DESC:
      'No se encontraron rutas de aprendizaje para el período seleccionado.',
    LP_TABLE_ERROR_RETRY: 'Reintentar',
    // ── ANLT-271: KPI section — Métricas claves ──────────────────────────────
    // ── ANLT-271 · KPI Section — Métricas claves ─────────────────────────
    KPI_SECTION_HEADING: 'Métricas claves',
    KPI_SPARKLINE_A11Y: 'Tendencia',
    KPI_ENGAGED_LABEL: 'Colaboradores engaged Learning',
    KPI_ENGAGED_HELP:
      'Colaboradores con actividad en cursos o rutas en los últimos 30 días, sobre el total de colaboradores. Mide qué tan activa está la plataforma.',
    KPI_ENROLLMENTS_LABEL: 'Inscripciones',
    KPI_ENROLLMENTS_HELP:
      'Total de inscripciones a cursos acumuladas en el año (YTD). Incluye catálogo propio y catálogo Crehana.',
    KPI_COMPLETIONS_LABEL: 'Completados',
    KPI_COMPLETIONS_HELP:
      'Cursos finalizados al 100% de visualización. El completion rate compara completados vs. iniciados.',
    KPI_COMPLETED_HOURS_LABEL: 'Horas completadas',
    KPI_COMPLETED_HOURS_HELP:
      'Horas de reproducción acumuladas (progreso × duración, fuente bioprogress homogenizado). SCORM/contenido externo no registra reproducción.',
    KPI_CERTIFICATES_LABEL: 'Certificados emitidos',
    KPI_CERTIFICATES_DOWNLOAD_ACTION_TOOLTIP: 'Descargar certificados',
    KPI_CERTIFICATES_HELP:
      'Certificados generados al completar un curso con certificación habilitada.',
    KPI_CSAT_LABEL: 'CSAT promedio',
    KPI_CSAT_HELP:
      'Satisfacción promedio (1–5) de las encuestas de fin de curso respondidas en el período.',
    KPI_INACTIVE_LABEL: 'Usuarios inactivos (>30 días)',
    KPI_INACTIVE_HELP:
      'Usuarios activos sin ningún acceso a la plataforma en los últimos 30 días. Candidatos a reactivación. El umbral de 30 días es fijo y no depende del período seleccionado.',
    KPI_VS_PREV_PERIOD: 'vs período anterior',
    KPI_COMPLETION_RATE_SUFFIX: 'completion rate',
    KPI_SECTION_EMPTY_TITLE: 'Sin datos de aprendizaje',
    KPI_SECTION_EMPTY_DESCRIPTION:
      'Cuando haya métricas disponibles, las verás aquí.',
    KPI_SECTION_ERROR_RETRY: 'Reintentar',
    KPI_ENGAGED_FOOTER: 'Activos con cursos/rutas · Fuente: Learning events',
    KPI_ENROLLMENTS_FOOTER: 'Inscripciones acumuladas',
    KPI_COMPLETIONS_FOOTER: 'Cursos finalizados al 100%',
    KPI_COMPLETED_HOURS_FOOTER:
      'Progreso × duración · Fuente: bioprogress homogenizado',
    KPI_CERTIFICATES_FOOTER: 'Cursos con certificación habilitada',
    KPI_CSAT_FOOTER: 'Encuestas post-curso',
    KPI_INACTIVE_FOOTER: 'Sin acceso en 30+ días',
    KPI_INACTIVE_LINK_LABEL: 'Ver listado',
    // Rich sublabels for KPIs that expose numerator/denominator (ANLT-271/272)
    KPI_ENGAGED_SUBLABEL_PREFIX: 'de {{denominator}} colaboradores',
    KPI_ENGAGED_SUBLABEL_HIGHLIGHT: 'engagement',
    KPI_HOURS_SUBLABEL_SUFFIX: 'promedio · por colaborador activo',
    KPI_CSAT_SUBLABEL_SUFFIX: 'respuestas',
    KPI_INACTIVE_SUBLABEL_SUFFIX: 'de {{denominator}} colaboradores',
    // Crehana AI inline CTA (ANLT-369) — footer of each of the 4 tabs
    AI_CTA_BADGE: 'Crehana AI',
    AI_CTA_TITLE: '¿Quieres hacer alguna pregunta específica?',
    AI_CTA_DESCRIPTION:
      'Pregúntale a Crehana AI sobre estos datos — completitud, horas de estudio, usuarios inactivos, segmentación por área y más.',
    AI_CTA_BUTTON: 'Pregúntale a Crehana AI',
    // ── Tab "Por usuarios" — KPI band (ANLT-296) ──────────────────────────────
    USERS_KPI_SECTION_HEADING: 'Métricas de usuarios',
    USERS_KPI_SECTION_ERROR_RETRY: 'Reintentar',
    USERS_ACTIVE_ONLY_BANNER:
      'Las estadísticas de la tabla incluyen a todos los colaboradores del reporte; la banda "Usuarios activos" cuenta solo los activos del período. Datos a tiempo casi real.',
    USERS_KPI_ACTIVE_LABEL: 'Usuarios activos',
    USERS_KPI_ACTIVE_HELP: 'Usuarios con estado activo en la plataforma.',
    USERS_KPI_STUDYING_LABEL: 'Usuarios estudiando',
    USERS_KPI_STUDYING_HELP:
      'Usuarios con al menos un curso iniciado en el período. Es un subconjunto de los usuarios activos.',
    USERS_KPI_STUDYING_FOOTER: 'con ≥1 curso iniciado · {{period}}',
    USERS_KPI_HOURS_LABEL: 'Promedio horas / usuario',
    USERS_KPI_HOURS_HELP:
      'Horas de estudio del período divididas entre los usuarios activos. Fuente: bioprogress (progreso × duración).',
    USERS_KPI_CERTIFICATE_LABEL: 'Usuarios con ≥1 certificado',
    USERS_KPI_CERTIFICATE_HELP:
      'Usuarios activos que obtuvieron al menos un certificado.',
    // ── Tab "Por usuarios" — Segmentación / breakdown (ANLT-296) ──────────────
    USERS_KPI_CERTIFICATE_FOOTER: '{{num}} de {{den}} usuarios activos',
    USERS_SORT_LABEL: 'Ordenar por',
    USERS_SORT_HOURS: 'Horas de estudio',
    USERS_SORT_CERTIFICATES: 'Certificados',
    USERS_BREAKDOWN_HEADING: 'Segmentación',
    USERS_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    USERS_BREAKDOWN_DESC:
      'Reagrupa las métricas por cualquier atributo de tu empresa — los predeterminados de la base de colaboradores o los atributos personalizados que hayas configurado.',
    USERS_BREAKDOWN_CAPTION: '{{active}} activos · {{studying}} estudiando',
    USERS_SEGMENT_FILTER_CHIP: 'Segmento: {{segment}}',
    // Shared prefix rendered to the LEFT of the active segment-filter chip on the
    // rutas/cursos/usuarios tables (ANLT-440): "Filtrado por: [chip]".
    SEGMENT_FILTER_PREFIX: 'Filtrado por:',
    USERS_BREAKDOWN_EMPTY: 'Cuando haya datos por segmento, los verás aquí.',
    USERS_BREAKDOWN_ERROR: 'No pudimos cargar la segmentación por usuarios.',
    USERS_BREAKDOWN_ERROR_RETRY: 'Reintentar',
    // ── Tab "Por rutas" — Segmentación / medallero (ANLT-395) ──────────────────
    ROUTES_SORT_LABEL: 'Ordenar por',
    ROUTES_SORT_COMPLETITUD: 'Completitud',
    ROUTES_SORT_ROUTES_COMPLETED: '% rutas completadas',
    ROUTES_SORT_COURSES_COMPLETED: '% cursos completados',
    ROUTES_SORT_EVALUATIONS: '% evaluaciones',
    ROUTES_SORT_PROJECTS: '% proyectos',
    ROUTES_SORT_USERS: 'Usuarios',
    ROUTES_BREAKDOWN_HEADING: 'Segmentación',
    ROUTES_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    ROUTES_BREAKDOWN_DESC:
      'Reagrupa las métricas de rutas por cualquier atributo de tu empresa — los predeterminados de la base de colaboradores o los atributos personalizados que hayas configurado. La cohorte de usuarios por segmento es la cohorte activa, por lo que no suma 1:1 contra la banda general.',
    ROUTES_BREAKDOWN_CAPTION: '{{users}} usuarios',
    ROUTES_BREAKDOWN_EMPTY: 'Cuando haya datos por segmento, los verás aquí.',
    ROUTES_BREAKDOWN_ERROR: 'No pudimos cargar la segmentación por rutas.',
    ROUTES_BREAKDOWN_ERROR_RETRY: 'Reintentar',
    // ── Pestaña "Por usuarios" — Tabla de usuarios / drawer (ANLT-298) ─────────
    USERS_TABLE_HEADING: 'Usuarios',
    USERS_TABLE_COUNT_LABEL: 'Usuarios',
    USERS_TABLE_COL_USER: 'Usuario',
    USERS_TABLE_COL_AREA: 'Área',
    USERS_TABLE_COL_COURSES: 'Cursos inscritos',
    USERS_TABLE_TOOLTIP_COURSES:
      'Cuenta las inscripciones creadas dentro del período seleccionado. No es un total histórico.',
    USERS_TABLE_COL_ASSIGNED: 'Asignados',
    USERS_TABLE_COL_COMPLETED: 'Finalizados',
    USERS_TABLE_COL_PROGRESS: '% Avance',
    USERS_TABLE_COL_ROUTES: 'Rutas',
    USERS_TABLE_COL_CERTIFICATES: 'Certif.',
    USERS_TABLE_COL_HOURS: 'Horas',
    USERS_TABLE_COL_LAST_ACTIVITY: 'Última actividad',
    USERS_TABLE_HOURS_VALUE: '{{hours}}h',
    USERS_TABLE_ACTIVITY_TODAY: 'Hoy',
    USERS_TABLE_ACTIVITY_YESTERDAY: 'Ayer',
    USERS_TABLE_ACTIVITY_DAYS_AGO: 'Hace {{count}} días',
    USERS_TABLE_SEARCH_PLACEHOLDER: 'Ingresar nombre de usuario',
    USERS_TABLE_EMPTY: 'Cuando haya datos de usuarios, los verás aquí.',
    USERS_TABLE_NO_RESULTS: 'Ningún usuario coincide con tu búsqueda.',
    USERS_TABLE_NEVER_LOGGED: 'Nunca ingresó',
    USER_DETAIL_CLOSE: 'Cerrar',
    USER_DETAIL_KPI_COMPLETED: 'Cursos finalizados',
    USER_DETAIL_KPI_ROUTES: 'Rutas completadas',
    USER_DETAIL_KPI_CERTIFICATES: 'Certificados',
    USER_DETAIL_KPI_HOURS: 'Horas de estudio',
    USER_DETAIL_ROUTES_TITLE: 'Rutas en progreso',
    USER_DETAIL_ACTIVITY_TITLE: 'Actividad reciente',
    USER_DETAIL_ACTIVITY_COMPLETED: 'Completado',
    USER_DETAIL_ACTIVITY_IN_PROGRESS: 'En progreso · {{progress}}%',
    // "N de M cursos" fraction per route-in-progress (BE MR !2025). NOTE: the count is over the
    // route's ASSIGNED courses, while the % is over its REQUIRED courses — they may not line up.
    USER_DETAIL_ROUTE_COURSES_FRACTION: '{{completed}} de {{assigned}} cursos',
    USER_DETAIL_VIEW_PROFILE: 'Ver perfil completo',
    USER_DETAIL_EMPTY: 'Este usuario aún no tiene datos para mostrar.',
    // 'Por usuarios' table — "Exportar reporte" action + report-generation toasts (ANLT-298)
    USERS_TABLE_EXPORT_REPORT: 'Exportar reporte',
    USERS_REPORT_GENERATION_SUCCESS: 'Reporte generado con éxito.',
    USERS_REPORT_GENERATION_SUCCESS_DESC:
      'Este reporte lo encontrarás en la sección Reportes.',
    USERS_REPORT_GENERATION_PENDING: 'Ya existe un reporte en generación',
    USERS_REPORT_GENERATION_ERROR: 'No se pudo generar el reporte',
    USERS_REPORT_GENERATION_ERROR_DESC:
      'Hubo un problema al generar tu reporte. Por favor, intenta nuevamente.',
    USERS_REPORT_PERMISSION_ERROR_TITLE:
      'No tienes permiso para realizar esta acción',
    USERS_REPORT_PERMISSION_ERROR_DESC:
      'Tu rol u organización no permite generar este reporte. Contacta al administrador si crees que es un error.',
    USERS_REPORT_RATE_LIMIT_TITLE: 'Máximo de intentos por minuto',
    USERS_REPORT_RATE_LIMIT_DESC:
      'Has alcanzado el límite de generación de reportes por minuto. Por favor espera unos minutos antes de intentar de nuevo.',
    // Courses KPI band (ANLT-292/293) — active-only metrics
    COURSES_KPI_SECTION_HEADING: 'Métricas de cursos',
    COURSES_KPI_BANNER:
      'Aquí encontrarás todos los cursos que has asignado dentro de rutas o como **cursos libres** a tus usuarios — catálogo propio y catálogo Crehana.',
    COURSES_KPI_CATALOG_LABEL: 'Catálogo:',
    COURSES_KPI_CATALOG_ALL: 'Ver todos',
    COURSES_KPI_CATALOG_OWN: 'Propios',
    COURSES_KPI_CATALOG_CREHANA: 'Crehana',
    COURSES_KPI_ACTIVE_LABEL: 'Cursos activos',
    COURSES_KPI_ACTIVE_HELP:
      'Cursos asignados actualmente a usuarios, dentro de rutas o como cursos libres. Incluye catálogo propio y Crehana.',
    COURSES_KPI_ACTIVE_FOOTER:
      '{{own}} propios · {{catalog}} de catálogo Crehana',
    COURSES_KPI_ENROLLMENTS_LABEL: 'Inscripciones',
    COURSES_KPI_ENROLLMENTS_HELP:
      'Total de inscripciones a cursos acumuladas en el año (YTD).',
    COURSES_KPI_ENROLLMENTS_FOOTER: 'acumuladas · {{period}}',
    COURSES_KPI_COMPLETED_LABEL: 'Completados',
    COURSES_KPI_COMPLETED_HELP:
      'Cursos finalizados al 100% de visualización en el año.',
    COURSES_KPI_COMPLETED_FOOTER: 'finalizados · {{period}}',
    COURSES_KPI_COMPLETION_RATE_LABEL: 'Tasa de finalización',
    COURSES_KPI_COMPLETION_RATE_HELP:
      'Promedio de cursos completados sobre cursos iniciados. Mide qué proporción de quienes empiezan, terminan.',
    COURSES_KPI_COMPLETION_RATE_FOOTER: 'promedio sobre cursos iniciados',
    COURSES_KPI_EMPTY_TITLE: 'Sin datos de cursos',
    COURSES_KPI_EMPTY_DESCRIPTION:
      'Cuando haya métricas disponibles, las verás aquí.',
    COURSES_KPI_ERROR_RETRY: 'Reintentar',
    // ── ANLT-294 round-4: Cursos medallero + buscador ─────────────────────────
    COURSES_SORT_LABEL: 'Ordenar por',
    COURSES_SORT_ENROLLMENTS: 'Inscripciones',
    COURSES_SORT_COMPLETED: 'Completados',
    COURSES_SORT_COMPLETION_RATE: 'Tasa de finalización',
    COURSES_BREAKDOWN_HEADING: 'Segmentación',
    COURSES_BREAKDOWN_GRANULAR_CHIP: 'Granular',
    COURSES_BREAKDOWN_DESC:
      'Reagrupa las métricas de cursos por cualquier atributo de tu empresa — los predeterminados de la base de colaboradores o los atributos personalizados que hayas configurado.',
    COURSES_BREAKDOWN_CAPTION: '{{active}} activos · {{started}} iniciados',
    COURSES_BREAKDOWN_EMPTY: 'Cuando haya datos por segmento, los verás aquí.',
    COURSES_BREAKDOWN_ERROR: 'No pudimos cargar la segmentación por cursos.',
    COURSES_BREAKDOWN_ERROR_RETRY: 'Reintentar',
    COURSES_TABLE_SEARCH_PLACEHOLDER: 'Buscar curso',
    COURSES_TABLE_NO_RESULTS_TITLE: 'Sin resultados',
    COURSES_TABLE_NO_RESULTS_DESCRIPTION:
      'No encontramos cursos que coincidan con tu búsqueda.',
    // Courses table + drawer (ANLT-294)
    COURSES_TABLE_SECTION_HEADING: 'Detalle de cursos',
    COURSES_TABLE_TITLE: 'Cursos',
    COURSES_SEGMENT_FILTER_CHIP: 'Segmento: {{segment}}',
    COURSES_TABLE_COL_COURSE: 'Curso',
    COURSES_TABLE_COL_TYPE: 'Tipo',
    COURSES_TABLE_COL_ENROLLED: 'Inscritos',
    COURSES_TABLE_COL_STARTED: 'Iniciaron',
    COURSES_TABLE_COL_COMPLETED: 'Completados',
    COURSES_TABLE_COL_EVAL_APPROVED: 'Eval. aprob.',
    COURSES_TABLE_COL_PROGRESS: '% Progreso',
    COURSES_TABLE_COL_REPRODUCTION_HOURS: 'Horas reprod.',
    COURSES_TABLE_COL_CERTIFICATES: 'Certif.',
    COURSES_TABLE_COL_CSAT: 'CSAT',
    COURSES_TABLE_TOOLTIP_ENROLLED:
      'Cuenta inscripciones (un usuario puede tener más de una), igual que el reporte de Cursos.',
    COURSES_TABLE_TOOLTIP_EVAL_APPROVED:
      'Porcentaje de evaluaciones aprobadas sobre el total de evaluaciones rendidas.',
    COURSES_TABLE_TOOLTIP_REPRODUCTION_HOURS:
      'Horas totales de video reproducidas por los usuarios inscritos en el curso.',
    COURSES_TABLE_TOOLTIP_CSAT:
      'Promedio de satisfacción reportado por los usuarios que respondieron la encuesta post-curso.',
    COURSES_TABLE_CSAT_EMPTY: 'Sin datos',
    COURSES_TABLE_EMPTY_TITLE: 'Sin cursos para este período',
    COURSES_TABLE_EMPTY_DESCRIPTION:
      'No encontramos cursos que coincidan con el período seleccionado.',
    COURSES_TABLE_ERROR_TITLE: 'No pudimos cargar la tabla',
    COURSES_TABLE_ERROR_DESCRIPTION:
      'Ocurrió un error al obtener los cursos. Reintenta.',
    COURSES_TABLE_ERROR_RETRY: 'Reintentar',
    // ── ANLT-294 round-3: "Exportar reporte" (REPORT_B2B_COURSES) ─────────────
    COURSES_TABLE_EXPORT_ACTION: 'Exportar reporte',
    COURSES_TABLE_EXPORT_STARTED_TITLE:
      'Generando reporte...esto puede tardar unos minutos',
    COURSES_TABLE_EXPORT_STARTED_DESC:
      'Este reporte lo encontrarás en la sección de Reportes cuando termine de generarse.',
    COURSES_TABLE_EXPORT_PENDING: 'Ya existe un reporte en generación',
    COURSES_TABLE_EXPORT_ERROR_TITLE: 'No pudimos generar el reporte',
    COURSES_TABLE_EXPORT_ERROR_DESC:
      'Hubo un problema al generar tu reporte. Por favor, intenta nuevamente.',
    COURSES_TABLE_EXPORT_PERMISSION_TITLE:
      'No tienes permiso para realizar esta acción',
    COURSES_TABLE_EXPORT_PERMISSION_DESC:
      'Tu rol u organización no permite generar este reporte. Contacta al administrador si crees que es un error.',
    COURSES_TABLE_EXPORT_RATE_LIMIT_TITLE: 'Máximo de intentos por minuto',
    COURSES_TABLE_EXPORT_RATE_LIMIT_DESC:
      'Has alcanzado el límite de generación de reportes por minuto. Por favor espera unos minutos antes de intentar de nuevo.',
    COURSES_TABLE_SOURCE_OWN: 'Propio',
    COURSES_TABLE_SOURCE_CATALOG: 'Catálogo',
    COURSES_TABLE_DRAWER_PERFORMANCE_HEADING: 'Rendimiento del curso',
    COURSES_TABLE_DRAWER_SATISFACTION_HEADING: 'Satisfacción',
    COURSES_TABLE_DRAWER_TOP_USERS_HEADING: 'Top de usuarios',
    COURSES_TABLE_DRAWER_CSAT_RESPONSES: 'Basado en {{count}} respuestas',
    COURSES_TABLE_DRAWER_CSAT_AVERAGE: 'CSAT promedio',
    COURSES_TABLE_DRAWER_CLOSE: 'Cerrar',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_USER: 'Usuario',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_PROGRESS: '% Avance',
    COURSES_TABLE_DRAWER_TOP_USERS_COL_POSITION: 'Posición',
    COURSES_TABLE_DRAWER_TOP_USERS_SEARCH: 'Buscar usuario',
    COURSES_TABLE_DRAWER_VIEW_PROFILE: 'Ver perfil completo',
    COURSES_TABLE_DRAWER_KPI_ENROLLED_LABEL: 'Inscritos',
    COURSES_TABLE_DRAWER_KPI_COMPLETED_LABEL: 'Completados',
    COURSES_TABLE_DRAWER_KPI_COMPLETION_RATE_LABEL: 'Tasa finalización',
    COURSES_TABLE_DRAWER_KPI_REPRODUCTION_HOURS_LABEL: 'Horas reprod.',
    COURSES_TABLE_DRAWER_ERROR: 'No pudimos cargar el detalle del curso.',
    // ── ANLT-288: Routes KPI section — Progreso de rutas en total ────────────
    ROUTES_KPI_SECTION_HEADING: 'Progreso de rutas en total',
    ROUTES_KPI_SECTION_ERROR_RETRY: 'Reintentar',
    ROUTES_KPI_COMPLETITUD_TOTAL_LABEL: 'Completitud total',
    ROUTES_KPI_COMPLETITUD_TOTAL_HELP:
      'Porcentaje promedio de avance de todas las rutas asignadas a los colaboradores.',
    ROUTES_KPI_COMPLETITUD_TOTAL_FOOTER: 'Promedio de avance de rutas',
    ROUTES_KPI_ROUTES_COMPLETED_LABEL: 'Rutas completadas',
    ROUTES_KPI_ROUTES_COMPLETED_HELP:
      'Porcentaje de rutas asignadas que fueron completadas al 100% por los colaboradores.',
    ROUTES_KPI_ROUTES_COMPLETED_FOOTER: 'Rutas al 100% de avance',
    ROUTES_KPI_COURSES_COMPLETED_LABEL: 'Cursos completados',
    ROUTES_KPI_COURSES_COMPLETED_HELP:
      'Porcentaje de cursos dentro de rutas que fueron completados al 100% por los colaboradores.',
    ROUTES_KPI_COURSES_COMPLETED_FOOTER: 'Cursos finalizados dentro de rutas',
    ROUTES_KPI_EVALUATIONS_APPROVED_LABEL: 'Evaluaciones aprobadas',
    ROUTES_KPI_EVALUATIONS_APPROVED_HELP:
      'Porcentaje de evaluaciones de rutas aprobadas sobre el total de evaluaciones rendidas.',
    ROUTES_KPI_EVALUATIONS_APPROVED_FOOTER: 'Evaluaciones aprobadas en rutas',
    ROUTES_KPI_PROJECTS_APPROVED_LABEL: 'Proyectos aprobados',
    ROUTES_KPI_PROJECTS_APPROVED_HELP:
      'Porcentaje de proyectos de rutas aprobados sobre el total de proyectos entregados.',
    ROUTES_KPI_PROJECTS_APPROVED_FOOTER: 'Proyectos aprobados en rutas',
    // ── ANLT-290: Routes deep-dive table columns ──────────────────────────────
    RDD_COL_ROUTE: 'Ruta',
    RDD_COL_ENROLLED: 'Inscritos',
    RDD_COL_COMPLETION: 'Avance',
    RDD_COL_COURSES_REQUIRED: 'Cursos req.',
    RDD_COL_ROUTE_COMPLETED: 'Ruta completada',
    RDD_COL_EVALUATIONS: 'Evaluaciones',
    RDD_COL_PROJECTS: 'Proyectos',
    RDD_COL_CSAT: 'CSAT',
    RDD_COL_STATUS: 'Estado',
    RDD_CSAT_NO_DATA: 'Sin datos',
    RDD_STATUS_ACTIVE: 'Activa',
    RDD_STATUS_ARCHIVED: 'Archivada',
    RDD_STATUS_EMPTY: 'Sin inscritos',
    // ── ANLT-290: Route detail drawer ──────────────────────────────────────────
    RDD_DRAWER_TITLE: 'Detalle de la ruta',
    RDD_DRAWER_SUBTITLE:
      '{{courses}} cursos · {{evaluations}} evaluaciones · {{projects}} proyectos',
    RDD_DRAWER_CLOSE: 'Cerrar',
    RDD_DRAWER_ERROR_RETRY: 'Reintentar',
    RDD_DRAWER_COMPLETION_TITLE: 'Completitud de la ruta',
    RDD_DRAWER_KPI_ENROLLED: 'Usuarios inscritos',
    RDD_DRAWER_KPI_AVG_PROGRESS: 'Avance promedio',
    RDD_DRAWER_KPI_COURSES_REQUIRED: 'Cursos requeridos',
    RDD_DRAWER_KPI_EVALUATIONS: 'Evaluaciones',
    RDD_DRAWER_KPI_PROJECTS: 'Proyectos',
    RDD_DRAWER_COURSES_TITLE: 'Cursos de la ruta',
    RDD_DRAWER_COURSES_COMPLETED: '{{count}} completados',
    RDD_DRAWER_TOP_USERS_TITLE: 'Top usuarios en la ruta',
    RDD_DRAWER_TOP_USERS_COL_POSITION: 'Posición',
    RDD_DRAWER_TOP_USERS_COL_USER: 'Usuario',
    RDD_DRAWER_TOP_USERS_COL_PROGRESS: '% Avance',
    RDD_DRAWER_TOP_USERS_SEARCH: 'Buscar usuario',
    RDD_DRAWER_VIEW_PROFILE: 'Ver perfil completo',
    RDD_DRAWER_EMPTY: 'No hay información para mostrar.',
    // ── ANLT-290: Routes deep-dive section shell ──────────────────────────────
    RDD_SECTION_HEADING: 'Detalle por rutas',
    RDD_TABLE_TITLE: 'Rutas',
    RDD_EMPTY_TITLE: 'Aún no hay datos de rutas',
    RDD_EMPTY_DESC: 'No encontramos rutas para el periodo seleccionado.',
    RDD_ERROR_RETRY: 'Reintentar',
    // ── ANLT-290 round-3: search + export ─────────────────────────────────────
    RDD_TABLE_SEARCH_PLACEHOLDER: 'Buscar ruta',
    RDD_TABLE_NO_RESULTS: 'Ninguna ruta coincide con tu búsqueda.',
    RDD_SEGMENT_FILTER_CHIP: 'Segmento: {{segment}}',
    RDD_EXPORT_BUTTON: 'Exportar reporte',
    RDD_EXPORT_STARTED_TITLE: 'Estamos generando tu reporte',
    RDD_EXPORT_STARTED_DESC:
      'Podrás descargarlo desde la sección Reportes en unos minutos.',
    RDD_EXPORT_PENDING: 'Ya existe un reporte en generación.',
    RDD_EXPORT_ERROR_TITLE: 'No pudimos generar tu reporte',
    RDD_EXPORT_ERROR_DESC: 'Inténtalo nuevamente en unos minutos.',
    RDD_EXPORT_RATE_LIMIT_TITLE: 'Máximo de intentos por minuto',
    RDD_EXPORT_RATE_LIMIT_DESC:
      'Espera un momento antes de volver a intentarlo.',
    RDD_EXPORT_PERMISSION_TITLE: 'No tienes permiso para realizar esta acción',
    RDD_EXPORT_PERMISSION_DESC:
      'Contacta a un administrador si crees que es un error.',
    // ── ANLT-466 · Horas de estudio (heatmap) ──────────────────────────────
    STUDY_HOURS_CARD_TITLE: 'Horas de estudio',
    STUDY_HOURS_CARD_DESCRIPTION:
      'Actividad de estudio de tu organización por semana, mes y año.',
    STUDY_HOURS_TAB_WEEKLY: 'Semanal',
    STUDY_HOURS_TAB_MONTHLY: 'Mensual',
    STUDY_HOURS_TAB_YEARLY: 'Anual',
    STUDY_HOURS_TAB_WEEKLY_AXIS_LEFT: 'Día',
    STUDY_HOURS_TAB_WEEKLY_AXIS_TOP: 'Hora',
    STUDY_HOURS_TAB_MONTHLY_AXIS_LEFT: 'Semanas del mes',
    STUDY_HOURS_TAB_MONTHLY_AXIS_LEFT_TOOLTIP: 'Semana del mes',
    STUDY_HOURS_TAB_MONTHLY_AXIS_TOP: 'Meses del año',
    STUDY_HOURS_TAB_YEARLY_AXIS_LEFT: 'Año',
    STUDY_HOURS_TAB_YEARLY_AXIS_TOP: 'Mes',
    STUDY_HOURS_INSIGHT_DAY:
      '{{moment}} es tu día con mayor actividad, con {{hours}} horas de estudio',
    STUDY_HOURS_INSIGHT_MONTH:
      '{{moment}} fue tu mes con mayor actividad, con {{hours}} horas de estudio',
    STUDY_HOURS_INSIGHT_YEAR:
      '{{moment}} fue tu año con mayor actividad, con {{hours}} horas de estudio',
    STUDY_HOURS_INSIGHT_EMPTY:
      'Aún no hay suficiente actividad para mostrar un insight',
    STUDY_HOURS_KPI_TOTAL_LABEL: 'Horas de estudio en total',
    STUDY_HOURS_KPI_TOTAL_TOOLTIP:
      'Suma de horas de reproducción de tu organización en el período seleccionado.',
    STUDY_HOURS_KPI_AVG_LABEL: 'Horas promedio por estudiante',
    STUDY_HOURS_KPI_AVG_TOOLTIP:
      'Horas de reproducción divididas entre los estudiantes con actividad en el período seleccionado.',
    STUDY_HOURS_KPI_VS_WEEK: 'vs semana anterior',
    STUDY_HOURS_KPI_VS_MONTH: 'vs mes anterior',
    STUDY_HOURS_KPI_VS_YEAR: 'vs año anterior',
    STUDY_HOURS_LEGEND_1: 'Sin actividad',
    STUDY_HOURS_LEGEND_2: 'Baja',
    STUDY_HOURS_LEGEND_3: 'Intermedia',
    STUDY_HOURS_LEGEND_4: 'Alta',
    STUDY_HOURS_LEGEND_TOOLTIP:
      'La intensidad del color indica cuántas horas de estudio hubo en esa celda.',
    STUDY_HOURS_CELL_TOOLTIP_LABEL: 'Horas de estudio:',
    STUDY_HOURS_EMPTY_TITLE: 'Sin actividad de estudio',
    STUDY_HOURS_EMPTY_DESCRIPTION:
      'No hay horas de estudio registradas en el período seleccionado.',
    STUDY_HOURS_ERROR_RETRY: 'Reintentar',
  },
};
